import { Injectable } from '@angular/core';
import { DetailedItem } from '../detailed-item';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()
export class DetailedInfoService {

  _item = new Subject<DetailedItem>();
  item: Observable<any>  = this._item.asObservable();

  update (item: DetailedItem) {
    this._item.next(item);
  }
}
